export interface SearchableProduct {
  id: string;
  name: string;
  category: string;
  path: string;
}

export const searchableProducts: SearchableProduct[] = [
  { id: 'visiting-cards', name: 'Visiting Cards', category: 'Products', path: '/order?product=visiting-cards' },
  { id: 'flex-banners', name: 'Flex Banners', category: 'Products', path: '/order?product=flex-banners' },
  { id: 'flyers', name: 'Flyers', category: 'Products', path: '/order?product=flyers' },
  { id: 'brochures', name: 'Brochures', category: 'Products', path: '/order?product=brochures' },
  { id: 'wedding-invites', name: 'Wedding Invitations', category: 'Products', path: '/order?product=wedding-invites' },
  { id: 'stickers-labels', name: 'Stickers & Labels', category: 'Products', path: '/order?product=stickers-labels' },
  { id: 'posters', name: 'Posters', category: 'Products', path: '/order?product=posters' },
  { id: 'id-cards', name: 'ID Cards & Badges', category: 'Products', path: '/order?product=id-cards' },
  { id: 'certificates', name: 'Certificates & Awards', category: 'Products', path: '/order?product=certificates' },
  { id: 'photo-frames', name: 'Photo Frames', category: 'Products', path: '/order?product=photo-frames' },
  { id: 'flex-printing', name: 'Flex Printing', category: 'Services', path: '/products' },
  { id: 'wall-posters', name: 'Wall Posters', category: 'Products', path: '/products' },
];
